import React from "react";
import { values } from "../../Data/data";
import icon from "../../assets/icon.png";
import { Buttons } from "../Buttons";
const Values = () => {
  return (
    <div className="w-full min-h-screen bg-black px-5 py-14 flex flex-wrap justify-center items-center sm:px-8 lg:px-16 lg:py-20">
      {/* Left Content - 60% */}
      <div className="w-full lg:w-3/5  p-4 text-white flex justify-center items-center">
        <div className="w-full rounded-[20px] border-[8px] border-[#191919] bg-[#141414] p-4 sm:p-6 lg:p-8">
          <div className="flex flex-wrap justify-between items-center">
            {values.slice(0, 2).map((data, index) => (
              <div
                key={index}
                className={`flex w-full flex-col gap-4 p-4 sm:w-1/2 ${
                  index === 0 ? "md:border-r-[2px] border-[#FFFFFF33]" : ""
                }`}
              >
                <div className="flex gap-2.5 items-center">
                  <img src={data.img} alt="" />
                  <h1 className="font-bold text-[24px]">{data.title}</h1>
                </div>
                <p className="text-[18px]">{data.detail}</p>
              </div>
            ))}
          </div>
          <hr className="hidden md:block" />
          <div className="flex flex-wrap justify-between items-center">
            {values.slice(2, 4).map((data, index) => (
              <div
                key={index}
                className={`flex w-full flex-col gap-4 p-4 sm:w-1/2 ${
                  index === 0 ? "md:border-r-[2px] border-[#FFFFFF33]" : ""
                }`}
              >
                <div className="flex gap-2.5 items-center">
                  <img src={data.img} alt="" />
                  <h1 className="font-bold text-[24px]">{data.title}</h1>
                </div>
                <p className="text-[18px]">{data.detail}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Right Content - 40% */}
<div className="w-full lg:w-2/5 h-full p-4 sm:p-6 text-white flex flex-col justify-center items-start gap-6">
  <div className="flex gap-[5px] items-center">
    <img
      src={icon}
      alt=""
      className="w-[24px] h-[24px] object-contain"
    />
    <p className="text-[18px] font-Quicksand text-white">
      Full-Service Real Estate & Property Management
    </p>
  </div>

  <h1 className="text-4xl leading-tight font-bold text-gradient sm:text-5xl">
    Our Values
  </h1>

  <p className="text-base leading-relaxed text-white font-light sm:text-lg">
    At the core of our company is a commitment to integrity,
    professionalism, and long-term client success. With over 20 years of
    experience managing residential and commercial properties throughout
    the San Francisco and Bay Area, our values shape every decision we
    make — from tenant relationships to investment strategy. We don’t just
    manage properties; we protect and grow our clients’ investments with
    accountability and care.
  </p>

  <Buttons title="Request a Free Consultation" width="250px" to="/contact" />
</div>
    </div>
  );
};

export default Values;
